/* Raghu  26/10/2022   3075154998   Search Filter Group card enhancements */
import React, {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {ResetStatus as resetStatus} from '../../../../../redux/reducers/EnableFramework/FilterGroup';
import SearchRuleGroupContainer from './SearchFilterGroupContainer';

function SearchFilterGroup({
  setTabValue,
  handleClose,
  setRecordFormatFilterGroupCode,
  setSelectedFilterGroupCode,
  setFilterGroupCode,
  setRecordFormatFilterGroupId,
  setIsCopyRowData,
}) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(resetStatus());
    setIsCopyRowData(false);
  }, []);
  return (
    <div>
      <div className={`mb-0`} elevation={0}>
        <SearchRuleGroupContainer
          setTabValue={setTabValue}
          handleClose={handleClose}
          setSelectedFilterGroupCode={setSelectedFilterGroupCode}
          setRecordFormatFilterGroupCode={setRecordFormatFilterGroupCode}
          setRecordFormatFilterGroupId={setRecordFormatFilterGroupId}
          setFilterGroupCode={setFilterGroupCode}
          setIsCopyRowData={setIsCopyRowData}
        />
      </div>
    </div>
  );
}

export default SearchFilterGroup;
